<template>
  <div class="scene-bar" v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0)">
    <div class="scene-list-box">
      <div class="scene-list">
        <draggable v-model="sceneListDrag" handle=".el-icon-rank" chosenClass="chosen" animation="300" @update="onDrag">
          <transition-group>
            <template v-for="(item, index) in sceneList">
              <div :key="item.id" class="scene-item" :class="{ active: item.id == materialId }">
                <div class="cover-box" @click="changeScene(item)">
                  <el-image v-if="item.status == 2" class="cover" :src="item.key" fit="cover" />
                  <div v-else class="cover-box-label">
                    <div>转码中</div>
                    <div class="v-ellipsis">{{ item.name }}</div>
                  </div>
                </div>
                <div v-if="item.status == 2" class="scene-info-row v-row">
                  <div class="name v-flex-1 v-ellipsis">{{ item.name }}</div>
                  <div v-if="isFirstGroup" class="operate-box">
                    <i @click="editScene(item)" class="icon el-icon-edit" title="编辑场景名称"></i>
                    <template v-if="groupList.length == 1 || (isFirstGroup && item.level == 0)">
                      <el-popconfirm title="确认删除？" @onConfirm="deleteScene(item, index)">
                        <i
                          v-loading="item.deleteLoading"
                          element-loading-background="rgba(0, 0, 0, 0)"
                          element-loading-spinner="el-icon-loading"
                          slot="reference"
                          class="icon el-icon-delete v-ml-5"
                          title="删除场景"
                        ></i>
                      </el-popconfirm>
                    </template>
                    <i v-if="groupList.length == 1" class="icon el-icon-rank v-ml-5" title="场景排序"></i>
                  </div>
                </div>
              </div>
            </template>
          </transition-group>
        </draggable>
      </div>
      <div
        v-if="isFirstGroup && sceneList.length"
        v-loading="uploadLoading"
        element-loading-text="上传中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0)"
        class="scene-add-btn"
        @click="chooseImage"
      >
        <template v-if="!uploadLoading">
          <i class="icon el-icon-plus"></i>
          <div class="txt">添加场景</div>
        </template>
      </div>
    </div>
    <input ref="file" type="file" hidden accept="*/image" multiple />
    <side-scene-edit v-if="isShowSceneEdit" :show.sync="isShowSceneEdit" :row="row" @success="getSceneList"></side-scene-edit>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import sideSceneEdit from './side-scene-edit';
import draggable from 'vuedraggable';
import upload from '@/utils/upload';

export default {
  components: { sideSceneEdit, draggable },

  data() {
    return {
      worksId: this.$route.query.id,
      isShowSceneEdit: false,
      row: null,
      uploadLoading: false,
    };
  },

  computed: {
    ...mapState('tour', ['krp', 'groupList', 'groupId', 'sceneList', 'materialId', 'isFirstGroup']),
    sceneListDrag: {
      get() {
        return this.sceneList;
      },
      set(val) {
        this.mutationSetSceneList(val);
      },
    },
    loading() {
      return this.sceneList.length == 0;
    },
  },

  methods: {
    ...mapMutations('tour', {
      mutationSetMaterialId: 'SET_MATERIAL_ID',
      mutationSetSceneList: 'SET_SCENE_LIST',
    }),

    ...mapActions('tour', {
      actionGetSceneList: 'getSceneList',
      actionGetSceneDetail: 'getSceneDetail',
      actionLoadKrp: 'loadKrp',
    }),

    //切换场景
    async changeScene(row) {
      if (row.status == 1 || this.materialId == row.id) {
        return;
      }
      this.mutationSetMaterialId(row.id);
      let sceneDetail = await this.actionGetSceneDetail({ worksId: this.worksId, materialId: this.materialId });
      this.actionLoadKrp({ krp: this.krp, sceneDetail });
    },

    //修改场景
    editScene(row) {
      this.row = row;
      this.isShowSceneEdit = true;
    },

    getSceneList() {
      this.actionGetSceneList({ worksId: this.worksId, groupId: this.groupId });
    },

    chooseImage() {
      if (this.uploadLoading) {
        return;
      }
      let $file = this.$refs.file;
      $file.click();
      $file.onchange = async (e) => {
        this.doUpload(e.target.files);
        $file.value = '';
      };
    },

    async doUpload(files) {
      this.uploadLoading = true;
      try {
				let _files = Array.from(files)
        let res = await upload.uploadFiles(files);
        let res2 = [];
				_files.forEach(item=>{
					res2.push(res.find(img=>img.name == item.name));
        })
        await this.api.works.addScene({
          works_id: this.worksId,
          group_id: this.groupId,
          keys: res2.map((item) => ({ key: item.key, name: item.name })),
        });
        this.$message.success('添加成功');
        this.getSceneList();
      } catch (e) {
        console.error(e);
      }
      this.uploadLoading = false;
    },

    //删除场景
    async deleteScene(row) {
      this.$set(row, 'deleteLoading', true);
      try {
        await this.api.works.deleteScene({ id: row.id });
        this.$message.success('删除成功');
        this.getSceneList();
      } catch (e) {
        console.error(e);
      }
      this.$set(row, 'deleteLoading', false);
    },

    //拖拽场景排序
    async onDrag() {
      try {
        await this.api.works.sceneSort({
          works_id: this.worksId,
          ids: this.sceneListDrag.map((item) => item.id),
          group_id: this.groupId,
        });
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.scene-bar {
  position: absolute;
  left: 0;
  top: 52px;
  background: rgba(0, 0, 0, 0.6);
  box-sizing: border-box;
  color: #fff;
  height: calc(100% - 52px);
  display: flex;
  align-items: stretch;
	transform: translateZ(1px);
}

.scene-list-box {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 155px;
}

.scene-list {
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 15px;

  .scene-item {
    width: 120px;
    margin-bottom: 20px;
    border: 2px solid #fff;
    position: relative;
  }

  .scene-item.chosen:after {
    content: '拖拽目标';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
  }

  .scene-item:last-child {
    margin-bottom: 0;
  }

  .operate-btn.disabled {
    color: #ccc;
    cursor: not-allowed;
  }

  .scene-item .cover-box {
    position: relative;
  }

  .scene-item .cover {
    display: block;
    width: 100%;
    height: 60px;
  }

  .scene-item.active {
    border: 2px solid #fbd14b;
  }

  .scene-item .scene-info-row {
    padding: 0 5px;
    height: 24px;
  }

  .scene-item .name {
    font-size: 12px;
    line-height: 24px;
    height: 24px;
  }

  .scene-item .operate-box {
    display: flex;
    align-items: center;
    height: 100%;
    padding-left: 5px;
  }

  .scene-item .operate-box .icon-upload {
    font-size: 13px;
    margin-right: 5px;
    position: relative;
    top: 1px;
  }

  .scene-item .operate-box .icon {
    cursor: pointer;
    font-weight: bold;
  }

  .scene-item .scene-operate {
    padding-left: 5px;
    right: 0;
    bottom: 0;
    cursor: pointer;
    font-weight: bold;
    line-height: 1;
  }
}

.page-mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
}

.scene-add-btn {
  height: 60px;
  width: 122px;
  border: 1px dashed #9a9a9a;
  border-radius: 4px;
  cursor: pointer;
  color: #9a9a9a;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-size: 12px;
  user-select: none;
  flex-shrink: 0;
  margin: 20px auto 0 auto;

  .icon {
    font-size: 16px;
  }
}

.new-line {
  margin-bottom: 40px !important;
}

.new-line:after {
  content: '新增场景';
  position: absolute;
  bottom: -35px;
  width: 100%;
  text-align: center;
}

.cover-box-label {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
